import m from "../../geodata/es2015/bahrainHigh";
window.am4geodata_bahrainHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/bahrainHigh.js
// module id = null
// module chunks = 